export const toPathComponents = (path = '') => {
    // split on / unless escaped with \
    return path.split(/(?<!\\)\//).filter(Boolean);
};
//# sourceMappingURL=to-path-components.js.map